import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { RelationsService } from "../../service/relations.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-relations',
  templateUrl: './relations.component.html',
  styleUrls: ['./relations.component.scss'],
  providers: [
    RelationsService,
    HttpModule
  ]
})
export class RelationsComponent implements OnInit {
  public relationtype: FormGroup;
  private economicGroupClassifications;
  private selectedClassificationID;
  public permissoes: any[] = [];
  private relations;
  public resultCount: number = 0;
  public orderby: string = "Nome";
  public sort: string = "asc";
  public currentPage: number = 0;
  public relationtypes: any[] = [];

  constructor(fb: FormBuilder, private relationsService: RelationsService, private flashMessagesService: FlashMessagesService, private router: Router) {
    this.relationtype = fb.group({
      'Nome': '',
      'Classificacao': '0'
    });
  }

  ngOnInit() {
    this.getEconomicGroupClassifications();
    this.getRelations(0,false);
    this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
  }
  setOrder(orderby) {
    if (this.orderby != orderby) {
      this.sort = "asc";
    } else {
      this.sort = this.sort == "asc" ? "desc" : "asc";
    }
    this.orderby = this.orderby != orderby ? orderby : this.orderby;
    this.getRelations(this.currentPage, false);
  }
  getEconomicGroupClassifications() {
    this.relationsService.getEconomicGroupClassifications().subscribe(result => {
      //this.economicGroupClassifications = result;
      this.economicGroupClassifications = result.Result;
      console.log(this.economicGroupClassifications);
    }, error => {
      console.log(error);
    });
  }
  paginar($event: any) {
    this.currentPage = $event;
    this.getRelations(this.currentPage, false);
  }
  getRelations(page: number, isSearch: boolean) {
    if (isSearch) {
      this.orderby = "Nome";
      this.sort = "asc";
      this.currentPage = 0;
    }
    console.log("CLas",this.relationtype.value.Classificacao.value);
    this.relationsService.getRelations(page, this.relationtype.value.Nome, this.relationtype.value.Classificacao, this.sort, this.orderby).subscribe(result => {
      console.log("result",result);
      if (result.Result) {
        this.relationtypes = result.Result;
        this.resultCount = result.Count;
        console.log(this.relationtypes);
      }
    }, error => {
      console.log(error);
    });
  }




}



// WEBPACK FOOTER //
// ./src/app/relations/component/relations/relations.component.ts